
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { DialogChangeInstanceComponent } from './dialog-change-instance.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LayoutModule } from '@angular/cdk/layout';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DialogChangeInstanceComponent,
  ],

  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    // BrowserModule,
    // BrowserAnimationsModule,
    // AppRoutingModule,
    FlexLayoutModule,
    // LayoutModule,
    MaterialModule,
  ],

  exports: [
    DialogChangeInstanceComponent,
  ],

  providers: [ ],

})

export class DialogChangeInstanceModule { }
